import fetchIntercept from "fetch-intercept";

export const AuthInterceptor = () => {
  fetchIntercept.register({
    request: function(url, config) {
      return [url, config];
    },

    requestError: function(error) {
      return Promise.reject(error);
    },

    response: function(response) {
      if (response.status === 503) {
        alert("مشکل در ارتباط با پایگاه داده");
      }
      if (response.status === 500 || response.statusText === "Service Unavailable") {
        alert("سامانه در دسترس نمیباشد");
      }
      return response;
    },

    responseError: function(error) {
      return Promise.reject(error);
    },
  });
};
